import { render, staticRenderFns } from "./ToolStd.vue?vue&type=template&id=1937b860&scoped=true&"
import script from "./ToolStd.vue?vue&type=script&lang=js&"
export * from "./ToolStd.vue?vue&type=script&lang=js&"
import style0 from "./ToolStd.vue?vue&type=style&index=0&id=1937b860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937b860",
  null
  
)

export default component.exports